// src/store/authConfig.ts
import { Configuration } from '@azure/msal-browser';

/** OIDC scopes for sign-in (works for redirect and popup). */
export const msalLoginScopes = ['openid', 'profile', 'email'] as const;
/** Hint Azure AD to use enterprise account path for better silent SSO in org tenants. */
export const msalDomainHint = 'organizations';
/** Prefer dev tenant accounts on staging and prod accounts elsewhere (override with env). */
export const preferredEmailDomain =
  import.meta.env.VITE_PREFERRED_LOGIN_DOMAIN ||
  (window.location.hostname.includes('staging') || window.location.hostname === 'localhost'
    ? 'meltwaterdev.com'
    : 'meltwater.com');
/** Optional exact account hint. If provided, it takes precedence over domain preference. */
export const preferredLoginHint = import.meta.env.VITE_PREFERRED_LOGIN_HINT;
const configuredRedirectUri =
  import.meta.env.VITE_MSAL_REDIRECT_URI || 'https://topdeals-staging.meltwater.com/topdeals';

const msalConfig: Configuration = {
  auth: {
    clientId: '4633c176-835b-42b0-8c6b-8f32c8175de9', // Replace with your Azure AD App Client ID
    authority: 'https://login.microsoftonline.com/25158429-e956-4c3d-9ce4-945dd3bbc264', // Replace with your tenant ID
    // Must be whitelisted in Azure AD App Registration.
    redirectUri: configuredRedirectUri,
  },
  cache: {
    // Needed for embedded/iframe scenarios where sessionStorage can appear empty across reloads.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export default msalConfig;